import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import VbzTextAreaInput from '../VbzTextAreaInput';

export default function ControlledMessage({ control, errors }: { control: Control; errors: any }) {
  const { t } = useTranslation('create_attendance');

  return (
    <Controller
      name="message"
      rules={{ required: true }}
      control={control}
      render={({ name, onChange }) => (
        <VbzTextAreaInput
          name={name}
          textLabel={t(name)}
          onChange={onChange}
          placeholder={t('messagePlaceHolder')}
          error={errors}
          errorMessage={t('messageError')}
          data-testid="controlledTextArea"
        />
      )}
    />
  );
}
